// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pestañas estilo navegador: la activa se eleva y se fusiona con la card,
   la inactiva queda como una pestaña "detrás", y a la derecha queda vacío. */
.Loads_tabs__nvfF9 {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  margin-bottom: 20px;
}

.Loads_tab__jeSno {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1.5px solid transparent;
  background: color-mix(in srgb, var(--dylo-muted) 9%, transparent);
  color: var(--dylo-muted);
  font-family: var(--font-sans);
  font-size: 15px;
  font-weight: 600;
  padding: 11px 22px;
  cursor: pointer;
  border-radius: 12px 12px 0 0;
  transition: color 0.15s ease, background-color 0.15s ease;
}
.Loads_tab__jeSno:hover {
  color: var(--dylo-text);
}

/* La pestaña Critical siempre en color de alerta */
.Loads_tabCritical__nIF9D {
  color: #e8590c;
}
.Loads_tabCritical__nIF9D:hover {
  color: #e8590c;
}

/* Activa: fondo de la card + borde superior/lados, sin borde inferior,
   y se solapa hacia abajo para "conectarse" con el contenido de la card. */
.Loads_tabActive__42kfU {
  color: var(--dylo-ink);
  background: var(--dylo-surface);
  border-color: var(--dylo-surface-border);
  border-bottom-color: var(--dylo-surface);
  box-shadow: 0 -3px 10px rgba(0, 0, 0, 0.06);
  margin-bottom: -1.5px;
  z-index: 1;
}
.Loads_tabCritical__nIF9D.Loads_tabActive__42kfU {
  color: #e8590c;
}

.Loads_badge__xqrxB {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: #e8590c;
  color: #fff;
  font-size: 11.5px;
  font-weight: 700;
  animation: Loads_dylo-pop__ANO2Q 0.2s ease both;
}

/* Indicador de nº de filtros activos en el botón Filter */
.Loads_filterCount__gKMla {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: var(--dylo-teal-700);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  animation: Loads_dylo-pop__ANO2Q 0.2s ease both;
}

.Loads_toolbar__X-Sgh {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

/*
 * Resalta el botón Filter cuando hay filtros aplicados, para que se entienda
 * que la vista está recortada y no es el total de loads.
 */
.Loads_toolbarFiltered__BfhhL .Loads_toolBtn__BxcTr:first-of-type {
  border-color: var(--dylo-teal-500);
  color: var(--dylo-teal-700);
  background: color-mix(in srgb, var(--dylo-teal-500) 10%, transparent);
}

/*
 * Cambio de contenido de la tabla al aplicar filtros / paginar.
 * El contenedor se remonta (key = viewKey) y entra con un fundido + escala
 * hacia dentro. Sin translate para no disparar barras de scroll.
 */
.Loads_tableSwap__qop1c {
  animation: Loads_table-swap__oOALo 0.4s cubic-bezier(0.16, 1, 0.3, 1) both;
  transform-origin: top center;
}
@keyframes Loads_table-swap__oOALo {
  from { opacity: 0; transform: scale(0.994); }
  to { opacity: 1; transform: scale(1); }
}
@media (prefers-reduced-motion: reduce) {
  .Loads_tableSwap__qop1c {
    animation: none;
  }
}

.Loads_search__xpmeT {
  flex: 1 1;
  min-width: 220px;
  max-width: 520px;
}

.Loads_toolBtn__BxcTr {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--dylo-field-bg);
  border: 1px solid var(--dylo-field-border);
  color: var(--dylo-text);
  border-radius: 10px;
  padding: 10px 16px;
  font-family: var(--font-sans);
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.12s ease;
}
.Loads_toolBtn__BxcTr:hover:not(:disabled) {
  background: color-mix(in srgb, var(--dylo-muted) 10%, transparent);
}
.Loads_toolBtn__BxcTr:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.Loads_spacer__Nyzom {
  flex: 1 1;
}

/* Total de cargas que cumplen el filtro, según el servidor. */
.Loads_total__rNn7d {
  font-size: 12.5px;
  color: var(--dylo-muted);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.Loads_pageSize__0rseM {
  position: relative;
}
.Loads_pageSizeBtn__TFuOs {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #1f1f1f;
  color: #fff;
  border: none;
  border-radius: 999px;
  padding: 9px 16px;
  font-family: var(--font-sans);
  font-size: 13.5px;
  cursor: pointer;
}
.Loads_pageSizeMenu__bjTcq {
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  background: var(--dylo-surface);
  border: 1px solid var(--dylo-surface-border);
  border-radius: 10px;
  box-shadow: var(--shadow-card);
  overflow: hidden;
  z-index: 30;
  min-width: 110px;
  transform-origin: top right;
  animation: Loads_dylo-dropdown__Oh3m\\+ 0.15s ease both;
}
.Loads_pageSizeOption__t5mC\\+ {
  display: block;
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
  color: var(--dylo-text);
  font-family: var(--font-sans);
  font-size: 13.5px;
  padding: 9px 16px;
  cursor: pointer;
}
.Loads_pageSizeOption__t5mC\\+:hover {
  background: color-mix(in srgb, var(--dylo-teal-700) 10%, transparent);
}
.Loads_pageSizeOptionActive__BK2S7 {
  color: var(--dylo-orange);
  font-weight: 600;
}

.Loads_state__PQ0MX {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-height: 300px;
  color: var(--dylo-muted);
}
.Loads_skeletonRows__HEoqq {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 6px 0;
}
.Loads_spinner__FOo61 {
  width: 38px;
  height: 38px;
  border: 3px solid var(--dylo-line);
  border-top-color: var(--dylo-teal-700);
  border-radius: 50%;
  animation: Loads_loads-spin__kchOj 0.75s linear infinite;
}
@keyframes Loads_loads-spin__kchOj {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Loads/Loads.module.css"],"names":[],"mappings":"AAAA;6EAC6E;AAC7E;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,iEAAiE;EACjE,wBAAwB;EACxB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,yDAAyD;AAC3D;AACA;EACE,uBAAuB;AACzB;;AAEA,mDAAmD;AACnD;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;2EAC2E;AAC3E;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,wCAAwC;EACxC,wCAAwC;EACxC,2CAA2C;EAC3C,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,+CAAkC;AACpC;;AAEA,0DAA0D;AAC1D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,+CAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;EAGE;AACF;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,qEAAqE;AACvE;;AAEA;;;;EAIE;AACF;EACE,0EAA6D;EAC7D,4BAA4B;AAC9B;AACA;EACE,OAAO,UAAU,EAAE,uBAAuB,EAAE;EAC5C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,0CAA0C;EAC1C,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,kEAAkE;AACpE;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA,8DAA8D;AAC9D;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,+BAA+B;EAC/B,4CAA4C;EAC5C,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,sDAAwC;AAC1C;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,qEAAqE;AACvE;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,sCAAsC;EACtC,kBAAkB;EAClB,wDAA2C;AAC7C;AACA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* Pestañas estilo navegador: la activa se eleva y se fusiona con la card,\n   la inactiva queda como una pestaña \"detrás\", y a la derecha queda vacío. */\n.tabs {\n  display: flex;\n  align-items: flex-end;\n  gap: 6px;\n  margin-bottom: 20px;\n}\n\n.tab {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 1.5px solid transparent;\n  background: color-mix(in srgb, var(--dylo-muted) 9%, transparent);\n  color: var(--dylo-muted);\n  font-family: var(--font-sans);\n  font-size: 15px;\n  font-weight: 600;\n  padding: 11px 22px;\n  cursor: pointer;\n  border-radius: 12px 12px 0 0;\n  transition: color 0.15s ease, background-color 0.15s ease;\n}\n.tab:hover {\n  color: var(--dylo-text);\n}\n\n/* La pestaña Critical siempre en color de alerta */\n.tabCritical {\n  color: #e8590c;\n}\n.tabCritical:hover {\n  color: #e8590c;\n}\n\n/* Activa: fondo de la card + borde superior/lados, sin borde inferior,\n   y se solapa hacia abajo para \"conectarse\" con el contenido de la card. */\n.tabActive {\n  color: var(--dylo-ink);\n  background: var(--dylo-surface);\n  border-color: var(--dylo-surface-border);\n  border-bottom-color: var(--dylo-surface);\n  box-shadow: 0 -3px 10px rgba(0, 0, 0, 0.06);\n  margin-bottom: -1.5px;\n  z-index: 1;\n}\n.tabCritical.tabActive {\n  color: #e8590c;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 10px;\n  background: #e8590c;\n  color: #fff;\n  font-size: 11.5px;\n  font-weight: 700;\n  animation: dylo-pop 0.2s ease both;\n}\n\n/* Indicador de nº de filtros activos en el botón Filter */\n.filterCount {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 9px;\n  background: var(--dylo-teal-700);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  animation: dylo-pop 0.2s ease both;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n/*\n * Resalta el botón Filter cuando hay filtros aplicados, para que se entienda\n * que la vista está recortada y no es el total de loads.\n */\n.toolbarFiltered .toolBtn:first-of-type {\n  border-color: var(--dylo-teal-500);\n  color: var(--dylo-teal-700);\n  background: color-mix(in srgb, var(--dylo-teal-500) 10%, transparent);\n}\n\n/*\n * Cambio de contenido de la tabla al aplicar filtros / paginar.\n * El contenedor se remonta (key = viewKey) y entra con un fundido + escala\n * hacia dentro. Sin translate para no disparar barras de scroll.\n */\n.tableSwap {\n  animation: table-swap 0.4s cubic-bezier(0.16, 1, 0.3, 1) both;\n  transform-origin: top center;\n}\n@keyframes table-swap {\n  from { opacity: 0; transform: scale(0.994); }\n  to { opacity: 1; transform: scale(1); }\n}\n@media (prefers-reduced-motion: reduce) {\n  .tableSwap {\n    animation: none;\n  }\n}\n\n.search {\n  flex: 1;\n  min-width: 220px;\n  max-width: 520px;\n}\n\n.toolBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--dylo-field-bg);\n  border: 1px solid var(--dylo-field-border);\n  color: var(--dylo-text);\n  border-radius: 10px;\n  padding: 10px 16px;\n  font-family: var(--font-sans);\n  font-size: 13.5px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background-color 0.12s ease;\n}\n.toolBtn:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--dylo-muted) 10%, transparent);\n}\n.toolBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.spacer {\n  flex: 1;\n}\n\n/* Total de cargas que cumplen el filtro, según el servidor. */\n.total {\n  font-size: 12.5px;\n  color: var(--dylo-muted);\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.pageSize {\n  position: relative;\n}\n.pageSizeBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  background: #1f1f1f;\n  color: #fff;\n  border: none;\n  border-radius: 999px;\n  padding: 9px 16px;\n  font-family: var(--font-sans);\n  font-size: 13.5px;\n  cursor: pointer;\n}\n.pageSizeMenu {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 4px);\n  background: var(--dylo-surface);\n  border: 1px solid var(--dylo-surface-border);\n  border-radius: 10px;\n  box-shadow: var(--shadow-card);\n  overflow: hidden;\n  z-index: 30;\n  min-width: 110px;\n  transform-origin: top right;\n  animation: dylo-dropdown 0.15s ease both;\n}\n.pageSizeOption {\n  display: block;\n  width: 100%;\n  text-align: left;\n  border: none;\n  background: transparent;\n  color: var(--dylo-text);\n  font-family: var(--font-sans);\n  font-size: 13.5px;\n  padding: 9px 16px;\n  cursor: pointer;\n}\n.pageSizeOption:hover {\n  background: color-mix(in srgb, var(--dylo-teal-700) 10%, transparent);\n}\n.pageSizeOptionActive {\n  color: var(--dylo-orange);\n  font-weight: 600;\n}\n\n.state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  min-height: 300px;\n  color: var(--dylo-muted);\n}\n.skeletonRows {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 6px 0;\n}\n.spinner {\n  width: 38px;\n  height: 38px;\n  border: 3px solid var(--dylo-line);\n  border-top-color: var(--dylo-teal-700);\n  border-radius: 50%;\n  animation: loads-spin 0.75s linear infinite;\n}\n@keyframes loads-spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `Loads_tabs__nvfF9`,
	"tab": `Loads_tab__jeSno`,
	"tabCritical": `Loads_tabCritical__nIF9D`,
	"tabActive": `Loads_tabActive__42kfU`,
	"badge": `Loads_badge__xqrxB`,
	"dylo-pop": `Loads_dylo-pop__ANO2Q`,
	"filterCount": `Loads_filterCount__gKMla`,
	"toolbar": `Loads_toolbar__X-Sgh`,
	"toolbarFiltered": `Loads_toolbarFiltered__BfhhL`,
	"toolBtn": `Loads_toolBtn__BxcTr`,
	"tableSwap": `Loads_tableSwap__qop1c`,
	"table-swap": `Loads_table-swap__oOALo`,
	"search": `Loads_search__xpmeT`,
	"spacer": `Loads_spacer__Nyzom`,
	"total": `Loads_total__rNn7d`,
	"pageSize": `Loads_pageSize__0rseM`,
	"pageSizeBtn": `Loads_pageSizeBtn__TFuOs`,
	"pageSizeMenu": `Loads_pageSizeMenu__bjTcq`,
	"dylo-dropdown": `Loads_dylo-dropdown__Oh3m+`,
	"pageSizeOption": `Loads_pageSizeOption__t5mC+`,
	"pageSizeOptionActive": `Loads_pageSizeOptionActive__BK2S7`,
	"state": `Loads_state__PQ0MX`,
	"skeletonRows": `Loads_skeletonRows__HEoqq`,
	"spinner": `Loads_spinner__FOo61`,
	"loads-spin": `Loads_loads-spin__kchOj`
};
export default ___CSS_LOADER_EXPORT___;
